/* =========================================================================
   entitlements.ts — per-user feature gates.

   The full-model Excel workbook carries the live formulas (the model itself),
   so it is restricted to internal users. PDF / TSV / CSV expose inputs and
   computed outputs, but never the live formulas, and stay available to
   everyone. This is a UI-level gate on a client-side app — it stops the
   convenient artefact, not a determined reverse-engineer of the bundle.
   ========================================================================= */

const EXCEL_EXPORT_DOMAINS = new Set(["stratosfyre.com"]);

export interface EntitlementContext {
  email?: string;
  /** Passcode-fallback sessions are treated as internal (dev / e2e). This holds
      only while scripts/check-bundle-wiring.mjs keeps env-less builds out of
      production — an env-less PROD deploy would put externals on passcode auth. */
  passcodeMode: boolean;
}

export function canExportExcel({
  email,
  passcodeMode,
}: EntitlementContext): boolean {
  if (passcodeMode) return true;
  const domain = email?.split("@")[1]?.toLowerCase();
  return !!domain && EXCEL_EXPORT_DOMAINS.has(domain);
}
